import React from 'react'
import styled from 'styled-components'

import { Box, ImageLoader } from '@usap/uicomponents'

const Container = styled(Box)`
  height: 96px;
  width: 96px;
  padding: 8px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    height: 108px;
    width: 108px;
  }
`

const Image = ({ product }) => {
  if (!product) return null
  if (!product?.image) return null

  return (
    <Container>
      <ImageLoader
        fit="contain"
        alt={product.title}
        src={product.image}
        width="100%"
        height="100%"
        cloudinaryParams="w_100,h_80"
      />
    </Container>
  )
}

export default Image
